/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import React                        from 'react';
import PropTypes                    from 'prop-types';
import { StyledTableList }          from '../../atoms/StyledTableList';
import { StyledTableListItem }      from '../../atoms/StyledTableListItem';
import { StyledTableListItemTitle } from '../../atoms/StyledTableListItemTitle';
import { StyledTableListItemText }  from '../../atoms/StyledTableListItemText';


/*********************************************************************************
 2. Component
 *********************************************************************************/

export const TableList = ({ items }) => (
    <StyledTableList>
        {items.map((item, index) => <StyledTableListItem key={index}>
            <StyledTableListItemTitle>{item.title}</StyledTableListItemTitle>
            <StyledTableListItemText>{item.text}</StyledTableListItemText>
        </StyledTableListItem>)}
    </StyledTableList>
);

TableList.propTypes = {
    items: PropTypes.array
};



// WEBPACK FOOTER //
// ./src/components/molecules/TableList/index.js